
import styled from '@emotion/styled';

export const ImgCustom = styled.img`
   height: 100px;
   float: left;
   margin-right: 16px;
   border-radius: 8px;
`;